import reduxIcon from "./redux.svg";

function Header() {
  return (
    <header className="App-Header">
      <img alt="Docker Logo" src={reduxIcon} height="35" />
      <h1>
        Redux <span style={{ fontWeight: 600 }}>Generator</span>
        <sub style={{ fontSize: ".5em", color: "#d5c3f4", left: "5px" }}>
          v1.0
        </sub>
      </h1>
    </header>
  );
}

export default Header;
